/* eslint-disable */
import React from 'react';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ConfigProvider, theme, Card, Row, Col } from 'antd';

import PageHeader from '@/components/PageHeader';
import { SelectC, DatePickerC } from '@/i2antdV5';

import { fetchDBSummary } from '@/redux/dashboard/dbSummary/dbSummaryTypeSlice';
import { fetchCustomerSatisfaction } from '@/redux/dashboard/getCustomerSatisfaction/customerSatisfactionSlice';
import { fetchHomeServiceMonthlyList } from '@/redux/dashboard/getHomeServiceMonthlyList/homeServiceMonthlyListSlice';
import { fetchHomeServiceSummary } from '@/redux/dashboard/getHomeServiceSummary/homeServiceSummarySlice';
import { fetchProductSummary } from '@/redux/dashboard/getProductSummary/productSummarySlice';
import { fetchPackageSummary } from '@/redux/dashboard/getPackageSummary/packageSummarySlice';
import { fetchPackageMonthlyList } from '@/redux/dashboard/getPackageMonthlyList/packageMonthlyListSlice';
import { fetchStoreList } from '@/redux/dashboard/storeList/storeSlice';
import { fetchStoreRoomStatus } from '@/redux/dashboard/getStoreRoomStatus/storeRoomStatusSlice';
import { fetchCommandCenterOccupiedRooms } from '@/redux/dashboard/commandCenterOccupiedRooms/commandCenterOccupiedRoomsSlice';
import { fetchCommandCenterStaffAgentsPage } from '@/redux/dashboard/commandCenterStaffAgentsPage/commandCenterStaffAgentsPageSlice';
import { fetchStaffList } from '@/redux/dashboard/staffList/StaffSlice';
import { fetchServiceCompletionRateSummary } from '@/redux/dashboard/getServiceCompletionRateSummary/serviceCompletionRateSummarySlice';

import { fetchERPSalesReportHomeSummary } from '@/redux/erp/erpSalesReportHomeSummarySlice';
import { fetchERPgetStoreAnnualStatistics } from '@/redux/erp/erpgetStoreAnnualStatistics';
import { fetchERPgetStoreList } from '@/redux/erp/erpgetStoreList';
import { fetchERPStoreSalesTaget } from '@/redux/erp/erpStoreSalesTaget';
import { fetchERPStoreDataByDay } from '@/redux/erp/getERPStoreDataByDay';

import CalendarDashboard from '@/views/commandCenter/modal/CalendarDashboard';
import ServiceAlertsPanel from '@/views/commandCenter/modal/ServiceAlertsPanel';
import RevenueSummaryCard from '@/views/commandCenter/modal/RevenueSummaryCard';
import HeatMapVisualization from '@/views/commandCenter/modal/HeatMapVisualization';
import MaternityPackagesManagement from '@/views/commandCenter/modal/MaternityPackagesManagement';
import HomeServicePackages from '@/views/commandCenter/modal/HomeServicePackages';
import RoomsManagementModule from '@/views/commandCenter/modal/RoomsManagementModule';
import StaffManagementModule from '@/views/commandCenter/modal/StaffManagementModule';
import CompletionRateAnalytics from '@/views/commandCenter/modal/CompletionRateAnalytics';
import ServiceCompletion from '@/views/commandCenter/modal/SverviceCompletionAnalytics';
import CustomerSatisfactionAnalytics from '@/views/commandCenter/modal/CustomerSatisfactionAnalytics';
import { COMPLETION_RATE_CONFIG } from '@/views/commandCenter/config';
import i2Math from '@/utils/i2Math';

import QueryManager from '@/utils/queryManager';
import ApiPollingManager from '@/utils/ApiPollingManager';
import { formatERPDate } from '@/utils/queryConfig';

import '@/views/commandCenter/Page.less';
import './Page.less';

const breadcrumbList = [{ breadcrumbName: '首页' }, { breadcrumbName: 'dashboard' }];

const getTodayDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDefaultQuery = () => ({
  date: getTodayDate(),
  store_id: '16',
});

const defaultQuery = getDefaultQuery();

const COL_LAYOUT_CONFIG = {
  smallCard: {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 6,
    xl: 6,
  },
  largeCard: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
  },
  packageCard: {
    xs: 24,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    className: 'maternity-col',
  },
  quarterCard: {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6,
  },
  fullWidth: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
  },
};

const getAPIConfig = (componentInstance) => ({
  once: [
    {
      name: 'fetchStoreList',
      dispatch: fetchStoreList,
      getParams: () => ({
        serviceType: 'default',
        dataType: 'storeOption',
      }),
    },
    {
      name: 'fetchERPgetStoreList',
      dispatch: fetchERPgetStoreList,
      getParams: () => ({}),
    },
    {
      name: 'fetchStaffList',
      dispatch: fetchStaffList,
      getParams: (query) => ({ query: { ...query } }),
    },
  ],
  realtime: [],
  polling: [],
  manual: [
    {
      name: 'fetchDBSummary',
      dispatch: fetchDBSummary,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchProductSummary',
      dispatch: fetchProductSummary,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchCustomerSatisfaction',
      dispatch: fetchCustomerSatisfaction,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchHomeServiceSummary',
      dispatch: fetchHomeServiceSummary,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchHomeServiceMonthlyList',
      dispatch: fetchHomeServiceMonthlyList,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchPackageSummary',
      dispatch: fetchPackageSummary,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchPackageMonthlyList',
      dispatch: fetchPackageMonthlyList,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchStoreRoomStatus',
      dispatch: fetchStoreRoomStatus,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchCommandCenterOccupiedRooms',
      dispatch: fetchCommandCenterOccupiedRooms,
      getParams: (query) => {
        const rawId = query?.store_id;
        const hasStoreId =
          rawId !== undefined && rawId !== null && String(rawId).trim() !== '';
        const listQuery = {
          storeId: hasStoreId ? String(rawId).trim() : '',
          checkInStatus: 2,
          keyword: '',
          pageNumber: 1,
          pageSize: 20,
        };
        return { query: listQuery };
      },
    },
    {
      name: 'fetchCommandCenterStaffAgentsPage',
      dispatch: fetchCommandCenterStaffAgentsPage,
      getParams: (query) => {
        const rawId = query?.store_id;
        const hasStoreId =
          rawId !== undefined && rawId !== null && String(rawId).trim() !== '';
        const pageQuery = {
          storeId: hasStoreId ? String(rawId).trim() : '',
          state: '1',
          pageNumber: 1,
          pageSize: 20,
        };
        return { query: pageQuery };
      },
    },
    {
      name: 'fetchStaffList',
      dispatch: fetchStaffList,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchServiceCompletionRateSummary',
      dispatch: fetchServiceCompletionRateSummary,
      getParams: (query) => ({ query: { ...query } }),
    },
    {
      name: 'fetchERPSalesReportHomeSummary',
      dispatch: fetchERPSalesReportHomeSummary,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          date: formatERPDate(query.date, 'day'),
          depart: 'sale',
        };
        return { query: formatQuery };
      },
    },
    {
      name: 'fetchERPStoreSalesTaget',
      dispatch: fetchERPStoreSalesTaget,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          month: formatERPDate(query.date, 'month'),
          depart: 'sale',
        };
        return { query: formatQuery };
      },
    },
    {
      name: 'fetchERPSalesReportStoreAnnualSummary',
      dispatch: fetchERPgetStoreAnnualStatistics,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          year: String(dayjs(query.date).year()),
          projectName: 'all',
        };
        return { serviceType: 'all', query: formatQuery };
      },
    },
    {
      name: 'fetchERPSalesReportStoreAnnualSummary',
      dispatch: fetchERPgetStoreAnnualStatistics,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          year: String(dayjs(query.date).year()),
          projectName: '产后复原',
        };
        return { serviceType: 'postpartum', query: formatQuery };
      },
    },
    {
      name: 'fetchERPSalesReportStoreAnnualSummary',
      dispatch: fetchERPgetStoreAnnualStatistics,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          year: String(dayjs(query.date).year()),
          projectName: '销售业绩',
        };
        return { serviceType: 'package', query: formatQuery };
      },
    },
    {
      name: 'fetchERPSalesReportStoreAnnualPrevYearPackage',
      dispatch: fetchERPgetStoreAnnualStatistics,
      getParams: (query) => {
        const user = componentInstance?.props?.app?.user ?? {};
        const formatQuery = {
          userId: user.oa_id,
          companyId: user.com_id,
          year: String(dayjs(query.date).year() - 1),
          projectName: '销售业绩',
          writeMainSlot: false
        };
        return { serviceType: 'package', query: formatQuery };
      },
    },
    {
      name: 'fetchERPStoreDataByDay',
      dispatch: fetchERPStoreDataByDay,
      getParams: (query) => ({
        query: {
          date: formatERPDate(query.date, 'day'),
        },
      }),
    },
  ],
});

class WorldCommandCenterPage extends React.Component {
  constructor(props) {
    super(props);
    this.lastUpdateTime = 0;
    this.lastUpdateKey = null;
    this._cachedErpStoreData = null;
    this._cachedErpStoreDataKey = null;
    this._cachedErpStoreDataByDay = null;
    this._cachedErpStoreDataByDayKey = null;
    this._enhancedProps = null;

    this.queryManager = new QueryManager(defaultQuery, {
      syncToUrl: false,
    });

    this.apiManager = new ApiPollingManager(getAPIConfig(this), this);

    this.queryManager.setUpdateCallback((query) => {
      this.apiManager.fetchData(query, true);
    });

    props.navigate && this.queryManager.setNavigate(props.navigate);
  }

  convertStoreListToMap = (storeList) => {
    if (!Array.isArray(storeList)) {
      return {};
    }
    return storeList.reduce((acc, item) => {
      if (item && item.id !== undefined) {
        acc[String(item.id)] = item;
      }
      return acc;
    }, {});
  };

  getProcessedErpStoreAnnualStatistics = () => {
    const { erpStoreAnnualStatisticsObj } = this.props;

    if (!erpStoreAnnualStatisticsObj) {
      return null;
    }

    // 基于 Redux 子树引用缓存；不能只用 store_list.length，否则金额变化但门店数不变时会拿到旧数据
    const cacheKey = erpStoreAnnualStatisticsObj;

    if (this._cachedErpStoreData && this._cachedErpStoreDataKey === cacheKey) {
      return this._cachedErpStoreData;
    }

    const processServiceType = (serviceTypeData) => {
      if (!serviceTypeData) return null;
      const { store_list, ...rest } = serviceTypeData;
      return {
        ...rest,
        store_map: this.convertStoreListToMap(store_list),
      };
    };

    const processYearMap = (rawByYear, processor) => {
      if (!rawByYear || typeof rawByYear !== 'object') {
        return {};
      }
      return Object.keys(rawByYear).reduce((acc, y) => {
        acc[y] = processor(rawByYear[y]);
        return acc;
      }, {});
    };

    const processed = {
      ...erpStoreAnnualStatisticsObj,
      all: processServiceType(erpStoreAnnualStatisticsObj.all),
      postpartum: processServiceType(erpStoreAnnualStatisticsObj.postpartum),
      package: processServiceType(erpStoreAnnualStatisticsObj.package),
      allByYear: processYearMap(erpStoreAnnualStatisticsObj.allByYear, processServiceType),
      postpartumByYear: processYearMap(
        erpStoreAnnualStatisticsObj.postpartumByYear,
        processServiceType
      ),
      packageByYear: processYearMap(erpStoreAnnualStatisticsObj.packageByYear, processServiceType)
    };

    this._cachedErpStoreData = processed;
    this._cachedErpStoreDataKey = cacheKey;

    return processed;
  };

  getProcessedErpStoreDataByDay = () => {
    const { erpStoreDataByDayObj } = this.props;

    if (!erpStoreDataByDayObj?.data?.list) {
      return erpStoreDataByDayObj;
    }

    const cacheKey = erpStoreDataByDayObj.data.list.length;

    if (this._cachedErpStoreDataByDay && this._cachedErpStoreDataByDayKey === cacheKey) {
      return this._cachedErpStoreDataByDay;
    }

    const store_map = this.convertStoreListToMap(erpStoreDataByDayObj.data.list);

    const processed = {
      ...erpStoreDataByDayObj,
      data: {
        ...erpStoreDataByDayObj.data,
        store_map,
      },
    };

    this._cachedErpStoreDataByDay = processed;
    this._cachedErpStoreDataByDayKey = cacheKey;

    return processed;
  };

  getMonthRevenue = (serviceType) => {
    const processedErpStoreAnnualStatisticsObj = this.getProcessedErpStoreAnnualStatistics();
    const query = this.queryManager.getQuery();

    if (!query?.date || !processedErpStoreAnnualStatisticsObj) {
      return 0;
    }

    const serviceData = processedErpStoreAnnualStatisticsObj?.[serviceType];
    const storeMap = serviceData?.store_map;
    if (!storeMap || typeof storeMap !== 'object') {
      return 0;
    }

    const currentMonthNum = dayjs(query.date).month() + 1;
    const matchCurrentMonth = (item) => parseInt(String(item.month), 10) === currentMonthNum;

    const rawId = query?.store_id;
    const hasStoreId = rawId !== undefined && rawId !== null && String(rawId).trim() !== '';

    if (hasStoreId) {
      const storeObj = storeMap[String(rawId)];
      if (!storeObj?.list?.length) {
        return 0;
      }
      const monthData = storeObj.list.find(matchCurrentMonth);
      return monthData?.sum || 0;
    }

    let sum = 0;
    Object.values(storeMap).forEach((storeObj) => {
      if (!storeObj?.list?.length) return;
      const monthData = storeObj.list.find(matchCurrentMonth);
      sum = i2Math.i2Add(sum, Number(monthData?.sum) || 0);
    });
    return sum;
  };

  getStoreDataByDay = () => {
    const erpStoreDataByDayObj = this.getProcessedErpStoreDataByDay();
    const query = this.queryManager.getQuery();
    const storeMap = erpStoreDataByDayObj?.data?.store_map;

    if (!storeMap || typeof storeMap !== 'object') {
      return {};
    }

    const rawId = query?.store_id;
    const hasStoreId = rawId !== undefined && rawId !== null && String(rawId).trim() !== '';

    if (hasStoreId) {
      return storeMap[String(rawId)] || {};
    }

    let healthSum = 0;
    let salesSum = 0;
    Object.values(storeMap).forEach((row) => {
      if (!row || typeof row !== 'object') return;
      healthSum = i2Math.i2Add(healthSum, Number(row.health) || 0);
      salesSum = i2Math.i2Add(salesSum, Number(row.sales) || 0);
    });
    return { health: healthSum, sales: salesSum };
  };

  componentDidMount() {
    const todayDate = getTodayDate();
    this.queryManager.defaultQuery = {
      ...this.queryManager.defaultQuery,
      date: todayDate,
    };

    const { location } = this.props;
    const initializedQuery = this.queryManager.initialize(location);

    if (!initializedQuery?.date) {
      initializedQuery.date = todayDate;
      this.queryManager.setQuery(initializedQuery, { autoFetch: false });
    }

    const originalFetchData = this.apiManager.fetchData.bind(this.apiManager);
    this.apiManager.fetchData = async (value, showErrorDialog = true) => {
      if (value) {
        const oldCallback = this.queryManager.onUpdateCallback;
        this.queryManager.setUpdateCallback(null);

        this.queryManager.updateQuery(value, undefined, {
          autoFetch: false,
          syncToUrl: this.queryManager.syncToUrl,
        });

        this.queryManager.setUpdateCallback(oldCallback);
      }

      const currentQuery = this.queryManager.getQuery();
      this.apiManager.currentQuery = currentQuery;

      return originalFetchData(currentQuery, showErrorDialog);
    };

    const originalExecuteApiCall = this.apiManager.executeApiCall.bind(this.apiManager);
    this.apiManager.executeApiCall = async (config, showErrorDialog = true) => {
      this.apiManager.currentQuery = this.queryManager.getQuery();
      return originalExecuteApiCall(config, showErrorDialog);
    };

    const originalHandlePageVisible = this.apiManager.handlePageVisible.bind(this.apiManager);
    this.apiManager.handlePageVisible = () => {
      if (!this.apiManager.isPageVisible) {
        this.apiManager.isPageVisible = true;
        const currentQuery = this.queryManager.getQuery();
        this.apiManager.currentQuery = currentQuery;
        this.apiManager.fetchData(currentQuery, false);
        this.apiManager.startRealtimePolling();
        this.apiManager.startPolling();
      }
    };

    this.apiManager.currentQuery = initializedQuery;
    this.apiManager.init(initializedQuery);
  }

  componentDidUpdate(prevProps) {
    this.apiManager.checkReduxErrors(prevProps, (props) => ({
      fetchDBSummary: props.dbSummaryObj,
      fetchProductSummary: props.productSummaryObj,
    }));

    if (prevProps.erpStoreAnnualStatisticsObj !== this.props.erpStoreAnnualStatisticsObj) {
      this._cachedErpStoreData = null;
      this._cachedErpStoreDataKey = null;
    }

    if (prevProps.erpStoreDataByDayObj !== this.props.erpStoreDataByDayObj) {
      this._cachedErpStoreDataByDay = null;
      this._cachedErpStoreDataByDayKey = null;
    }

    if (
      prevProps.erpStoreAnnualStatisticsObj !== this.props.erpStoreAnnualStatisticsObj ||
      prevProps.erpStoreDataByDayObj !== this.props.erpStoreDataByDayObj ||
      prevProps.commandCenterOccupiedRoomsObj !== this.props.commandCenterOccupiedRoomsObj ||
      prevProps.commandCenterStaffAgentsPageObj !== this.props.commandCenterStaffAgentsPageObj
    ) {
      this._enhancedProps = null;
    }
  }

  componentWillUnmount() {
    this.apiManager.cleanup();
  }

  isObject = (value) => typeof value === 'object' && value !== null;

  generateUpdateKey = (keyOrUpdates, value) => {
    if (typeof keyOrUpdates === 'string') {
      return `${keyOrUpdates}:${JSON.stringify(value)}`;
    }

    if (this.isObject(keyOrUpdates)) {
      const keys = Object.keys(keyOrUpdates).sort();
      return keys.map((k) => `${k}:${JSON.stringify(keyOrUpdates[k])}`).join('|');
    }

    return null;
  };

  hasQueryChanged = (keyOrUpdates, value, currentQuery) => {
    if (this.isObject(keyOrUpdates)) {
      return Object.keys(keyOrUpdates).some((key) => currentQuery[key] !== keyOrUpdates[key]);
    }

    if (typeof keyOrUpdates === 'string') {
      return currentQuery[keyOrUpdates] !== value;
    }

    return true;
  };

  isDuplicateCall = (updateKey, now) =>
    updateKey && this.lastUpdateKey === updateKey && now - this.lastUpdateTime < 300;

  updateQuery = (keyOrUpdates, value, options = {}) => {
    const isActionCall = this.isObject(keyOrUpdates) && options.syncToUrl === undefined;

    const now = Date.now();
    const updateKey = this.generateUpdateKey(keyOrUpdates, value);

    if (this.isDuplicateCall(updateKey, now)) {
      return this.queryManager.getQuery();
    }

    this.lastUpdateTime = now;
    this.lastUpdateKey = updateKey;

    const currentQuery = this.queryManager.getQuery();

    if (!this.hasQueryChanged(keyOrUpdates, value, currentQuery)) {
      return currentQuery;
    }

    const finalOptions = {
      autoFetch: true,
      syncToUrl: options.syncToUrl ?? (isActionCall ? false : this.queryManager.syncToUrl),
      ...options,
    };
    return this.queryManager.updateQuery(keyOrUpdates, value, finalOptions);
  };

  urlTypeFilterConfig = {
    serviceAlertsList: ['date'],
  };

  isValidValue = (val) => val !== undefined && val !== null && val !== '';

  buildQueryString = (options) => {
    const { query, urlType } = options;

    if (!this.isObject(query)) {
      return '';
    }

    const excludeFields = urlType ? this.urlTypeFilterConfig[urlType] ?? [] : [];

    const searchParams = new URLSearchParams();
    Object.keys(query).forEach((key) => {
      if (excludeFields.includes(key)) {
        return;
      }

      const val = query[key];
      if (this.isValidValue(val)) {
        searchParams.set(key, String(val));
      }
    });

    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : '';
  };

  fetchData = async (value, showErrorDialog = true) => this.apiManager.fetchData(value, showErrorDialog);

  render() {
    const { storeObj = {} } = this.props;
    const { default_storeOption: storeOption } = storeObj;

    let query = this.queryManager.getQuery();

    if (this.isValidValue(query.store_id)) {
      query = {
        ...query,
        store_id: String(query.store_id),
      };
    }

    const processedErpStoreAnnualStatisticsObj = this.getProcessedErpStoreAnnualStatistics();
    const processedErpStoreDataByDayObj = this.getProcessedErpStoreDataByDay();

    const monthRevenueData = {
      postpartum: this.getMonthRevenue('postpartum'),
      package: this.getMonthRevenue('package'),
    };

    const storeDataByDay = this.getStoreDataByDay();

    if (
      !this._enhancedProps ||
      this._enhancedProps.erpStoreAnnualStatisticsObj !== processedErpStoreAnnualStatisticsObj ||
      this._enhancedProps.erpStoreDataByDayObj !== processedErpStoreDataByDayObj ||
      this._enhancedProps.monthRevenueData?.postpartum !== monthRevenueData.postpartum ||
      this._enhancedProps.monthRevenueData?.package !== monthRevenueData.package ||
      this._enhancedProps.commandCenterOccupiedRoomsObj !== this.props.commandCenterOccupiedRoomsObj ||
      this._enhancedProps.commandCenterStaffAgentsPageObj !== this.props.commandCenterStaffAgentsPageObj
    ) {
      this._enhancedProps = {
        ...this.props,
        erpStoreAnnualStatisticsObj: processedErpStoreAnnualStatisticsObj || this.props.erpStoreAnnualStatisticsObj,
        erpStoreDataByDayObj: processedErpStoreDataByDayObj || this.props.erpStoreDataByDayObj,
        queryManager: this.queryManager,
        monthRevenueData,
        storeDataByDay,
      };
    }

    const enhancedProps = this._enhancedProps;

    return (
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorBgContainer: 'rgba(12, 22, 38, 0.92)',
            colorBorder: 'rgba(0, 212, 170, 0.25)',
            colorPrimary: '#2ee59d',
          },
        }}
      >
        <div className="world-command-center-root">
          <PageHeader breadcrumbList={breadcrumbList} embedTransparent />
          <div className="wcc-shell">
            <header className="wcc-toolbar">
              <div className="wcc-toolbar-meta">
                <div className="wcc-brand">
                  <span className="wcc-brand-title">GLOBAL COMMAND · 业务态势</span>
                  <span className="wcc-brand-sub">
                    顶栏筛选 · 左栏运营 · 中央营收与热力图 · 热力图下产康/到家套餐
                  </span>
                </div>
                <div className="wcc-live">
                  <span className="wcc-live-dot" aria-hidden />
                  <span>LIVE</span>
                </div>
              </div>
              <div className="wcc-toolbar-filters">
                <SelectC
                  label=""
                  query={query}
                  searchKey="store_id"
                  options={storeOption}
                  action={this.updateQuery}
                />
                <DatePickerC
                  label=""
                  query={query}
                  searchKey="date"
                  dateStrValue={true}
                  action={this.updateQuery}
                />
              </div>
            </header>

            <div className="wcc-content">
              <div className="i2-container">
                <Card className="i2-card-page wcc-card">
                  {/* 左栏运营 · 中央：营收 + 热力图 + 图下产康/到家；底部全宽与 commandCenter 一致 */}
                  <div className="wcc-map-layout">
                    <aside className="wcc-panel wcc-panel-left" aria-label="运营与预警">
                      <div className="wcc-panel-hd">OPERATIONS</div>
                      <div className="wcc-embed wcc-embed-calendar">
                        <CalendarDashboard />
                      </div>
                      <div className="wcc-panel-hd">SERVICE ALERTS</div>
                      <div className="wcc-embed wcc-embed-alerts">
                        <Link
                          to={`/client/commandCenter/serviceAlertsList${this.buildQueryString({
                            query,
                            urlType: 'serviceAlertsList',
                          })}`}
                          rel="noopener noreferrer"
                        >
                          <ServiceAlertsPanel />
                        </Link>
                      </div>
                    </aside>

                    <main className="wcc-main" aria-label="中央态势">
                      <div className="wcc-panel-hd wcc-panel-hd-inline">STRATEGIC OVERVIEW</div>
                      <div className="wcc-map-stage">
                        <div className="wcc-map-stage-label">HEAT MAP · 态势分布</div>
                        <div className="wcc-map-stage-inner">
                          <HeatMapVisualization
                            mapStyle="amap://styles/darkblue"
                            mapTheme="dark"
                          />
                        </div>
                      </div>
                      <div className="wcc-panel-hd wcc-revenue-hd">门店总营收</div>
                      <div className="wcc-embed wcc-embed-revenue wcc-revenue-summary-wrap">
                        <RevenueSummaryCard {...enhancedProps} />
                      </div>
                      <div className="wcc-panel-hd wcc-packages-hd">产康 / 到家套餐</div>
                      <Row gutter={[6, 6]} className="wcc-packages-row">
                        <Col {...COL_LAYOUT_CONFIG.packageCard}>
                          <MaternityPackagesManagement {...enhancedProps} />
                        </Col>
                        <Col {...COL_LAYOUT_CONFIG.packageCard}>
                          <HomeServicePackages {...enhancedProps} />
                        </Col>
                      </Row>
                    </main>
                  </div>

                  <div className="wcc-full-bleed command-center-page">
                    <Row gutter={[6, 6]} className="row-second-b">
                      <Col {...COL_LAYOUT_CONFIG.quarterCard}>
                        <ServiceCompletion {...this.props} />
                      </Col>
                      <Col {...COL_LAYOUT_CONFIG.quarterCard}>
                        <CustomerSatisfactionAnalytics {...this.props} />
                      </Col>
                      <Col {...COL_LAYOUT_CONFIG.quarterCard}>
                        <Link
                          to={`/client/roomsManagement${this.buildQueryString({
                            query,
                            urlType: 'roomsManagement',
                          })}`}
                          rel="noopener noreferrer"
                        >
                          <RoomsManagementModule {...enhancedProps} visualTheme="dark" />
                        </Link>
                      </Col>
                      <Col {...COL_LAYOUT_CONFIG.quarterCard}>
                        <Link
                          to={`/client/staffList${this.buildQueryString({
                            query,
                            urlType: 'serviceAlertsList',
                          })}`}
                          rel="noopener noreferrer"
                        >
                          <StaffManagementModule {...enhancedProps} visualTheme="dark" />
                        </Link>
                      </Col>
                    </Row>
                    <Row gutter={[6, 6]} className="row-third">
                      <Col {...COL_LAYOUT_CONFIG.fullWidth}>
                        <CompletionRateAnalytics
                          {...enhancedProps}
                          completionRateConfig={COMPLETION_RATE_CONFIG}
                        />
                      </Col>
                    </Row>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </ConfigProvider>
    );
  }
}

const WorldCommandCenterPageWrapper = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const dashboardState = useSelector((state) => state.dashboard ?? {});
  const erpState = useSelector((state) => state.erp ?? {});
  const appState = useSelector((state) => state.app ?? {});
  const orderState = useSelector((state) => state.order?.order || {});

  const props = {
    dispatch,
    location,
    navigate,
    app: appState,
    staffListObj: dashboardState.staffList ?? {},
    storeObj: dashboardState.storeList ?? {},
    dbSummaryObj: dashboardState.dbSummary ?? {},
    customerSatisfactionObj: dashboardState.customerSatisfaction ?? {},
    productSummaryObj: dashboardState.productSummary ?? {},
    homeServiceMonthlyListObj: dashboardState.homeServiceMonthlyList ?? {},
    homeServiceSummaryObj: dashboardState.homeServiceSummary ?? {},
    packageSummaryObj: dashboardState.packageSummary ?? {},
    packageMonthlyListObj: dashboardState.packageMonthlyList ?? {},
    storeRoomStatusObj: dashboardState.storeRoomStatus ?? {},
    commandCenterOccupiedRoomsObj: dashboardState.commandCenterOccupiedRooms ?? {},
    commandCenterStaffAgentsPageObj: dashboardState.commandCenterStaffAgentsPage ?? {},
    serviceCompletionRateSummaryObj: dashboardState.serviceCompletionRateSummary ?? {},
    erpSalesReportHomeSummaryObj: erpState.erpSalesReportHomeSummary ?? {},
    erpStoreAnnualStatisticsObj: erpState.erpgetStoreAnnualStatistics ?? {},
    erpStoreListObj: erpState.erpgetStoreList ?? {},
    erpStoreSalesTagetObj: erpState.erpStoreSalesTaget ?? {},
    erpStoreDataByDayObj: erpState.erpStoreDataByDay ?? {},
    erpRoomListObj: erpState.erpRoomList ?? {},
    orderObj: orderState.orderListPage ?? {},
  };

  return <WorldCommandCenterPage {...props} />;
};

export default WorldCommandCenterPageWrapper;
